import type * as React from "react";

import { cn } from "@/common/utils";

export function SectionEyebrow({
  index,
  children,
  className,
}: {
  index?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-3 font-mono text-[11px] tracking-[0.18em] uppercase",
        className,
      )}
    >
      {index && (
        <>
          <span style={{ color: "var(--cli-text-dim)" }}>{index}</span>
          <span
            className="h-px w-8"
            style={{ backgroundColor: "var(--cli-border)" }}
          />
        </>
      )}
      <span style={{ color: "var(--cli-text-muted)" }}>{children}</span>
    </div>
  );
}
